import { TabDTO } from "utils/domain/extended/tabDTO";
import { ExtendedTabsService } from "./extendedTabsService";

export interface ApiExtendedTabs {
    GetExternalTabs(scenarioId: string, workflowId: string): Promise<TabDTO[]>;
}

export const extendedTabsService = new ExtendedTabsService();
